import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomerFlowResetPassword from '../../components/customer/CustomerFlowResetPassword';
import { CustomerAppState } from '../../reducers/customer_ui';

const mapStateToProps = (state: CustomerAppState) => ({
  country: state.JurisdictionInfo.country,
  brand: state.JurisdictionInfo.brandCode,
  subJurisdictionCode: state.JurisdictionInfo.subJurisdictionCode,
  referrer: state.JurisdictionInfo.referrerName,
  createAccountString: state.rest.createAccountString,
  pending: !!state.rest.resetPasswordPending,
});

const mapDispatchToProps = (dispatch) => ({
  setResetPasswordSuccess: (value: boolean) => {
    dispatch({
      type: 'SET_RESET_PASSWORD_SUCCESS',
      payload: value,
    });
  },
  setResetPasswordPending: (value: boolean) => {
    dispatch({
      type: 'SET_RESET_PASSWORD_PENDING',
      payload: value,
    });
  },
});

const ConnectedResetPassword = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomerFlowResetPassword);

function ResetPasswordWithRouter(props) {
  const navigate = useNavigate();
  return <ConnectedResetPassword {...props} navigate={navigate} />;
}

export default ResetPasswordWithRouter;
